module.exports = __webpack_public_path__ + "static/media/barcode-alt.04d63a34.svg";